(() => {
  let pendingOutsideDismissal = null;
  let suppressUnderlyingClicksUntil = 0;
  let isTriggeringNativeClose = false;
  const formsSelector =
    'shopify-forms-embed, [id*="shopify-forms"], [class*="shopify-forms"], iframe[src*="shopify.com"][src*="forms"]';

  const isVisible = (element) => {
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.right > 0 &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.top < window.innerHeight &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.pointerEvents !== 'none' &&
      Number(style.opacity) > 0
    );
  };

  const findVisibleFormsPopup = () => {
    for (const host of document.querySelectorAll(formsSelector)) {
      if (!host.shadowRoot) continue;

      const wrapper = host.shadowRoot.querySelector('[data-sizing="form-wrapper"]');
      const modal = wrapper?.closest('[aria-modal="true"]') || host.shadowRoot.querySelector('[aria-modal="true"]');

      if (!wrapper || !modal || !isVisible(wrapper) || !isVisible(modal)) continue;

      return {
        host,
        wrapper,
        closeButton: host.shadowRoot.querySelector('[aria-label="Close modal"], [aria-label="Sluit modal"]'),
      };
    }

    return null;
  };

  const clickIsInsideWrapper = (event, wrapper) => event.composedPath().includes(wrapper);
  const clickIsInsideForms = (event) =>
    event
      .composedPath()
      .some((element) => element instanceof Element && element.matches(formsSelector));

  const closePopup = ({ closeButton }) => {
    if (closeButton instanceof HTMLElement) {
      isTriggeringNativeClose = true;
      closeButton.click();
      isTriggeringNativeClose = false;
      return;
    }

    document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
  };

  window.addEventListener(
    'pointerdown',
    (event) => {
      if (isTriggeringNativeClose) return;

      const popup = findVisibleFormsPopup();
      if (!popup) {
        pendingOutsideDismissal = null;
        return;
      }

      suppressUnderlyingClicksUntil = Date.now() + 1500;

      if (clickIsInsideWrapper(event, popup.wrapper)) {
        pendingOutsideDismissal = null;
        return;
      }

      pendingOutsideDismissal = { popup, expiresAt: Date.now() + 1500 };
      event.preventDefault();
    },
    true
  );

  window.addEventListener(
    'click',
    (event) => {
      if (isTriggeringNativeClose) return;

      if (clickIsInsideForms(event)) {
        pendingOutsideDismissal = null;
        suppressUnderlyingClicksUntil = Date.now() + 1500;
        return;
      }

      if (!pendingOutsideDismissal) {
        if (Date.now() > suppressUnderlyingClicksUntil) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      const { popup, expiresAt } = pendingOutsideDismissal;
      pendingOutsideDismissal = null;
      if (Date.now() > expiresAt || clickIsInsideWrapper(event, popup.wrapper)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      suppressUnderlyingClicksUntil = Date.now() + 1500;
      closePopup(popup);
    },
    true
  );
})();
